import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import { t } from "i18next";
import * as Yup from "yup";

import { AmountSchema } from "../../helpers/yup-schema";
import EmpActivityService from "../../services/emp_activity";

import NumericFormatField from "../../components/NumericFormatField";

const InitialValues = {
  amount: "",
  reference: "",
};

const ValidationSchema = AmountSchema().shape({
  reference: Yup.string().required(t("REQUIRED")).trim(),
});

function ConfirmSaveDataBankWithdrawal({
  formData = {},
  isOpened = false,
  toggleModal = () => {},
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitFn = async (values, { setSubmitting }) => {
    setSubmitting(false);

    const payload = {
      ...formData,
      ...values,
      amount: parseFloat(values.amount),
    };

    setIsLoading(true);
    await EmpActivityService.withdrawnFromBank(payload)
      .then((response) => {
        const { status, message } = response.data;

        if (status === 400) {
          toast.error(message);
          return;
        }

        toast.success(message);
        toggleModal(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Modal isOpen={isOpened} toggle={toggleModal} backdrop="static">
        <Formik
          initialValues={{ ...InitialValues, ...formData }}
          enableReinitialize={true}
          validationSchema={ValidationSchema}
          onSubmit={handleSubmitFn}
        >
          {({ values, isSubmitting, setFieldValue, setFieldTouched }) => (
            <Form>
              <ModalHeader toggle={() => toggleModal()}>
                {t("CONFIRM_DETAILS")}
              </ModalHeader>
              <ModalBody>
                <Row>
                  {/* Cheque Amount */}
                  <Col xs={6}>
                    <div className="mb-4">
                      <NumericFormatField
                        fieldName="amount"
                        fieldValue={values.amount}
                        fieldDecimalScale={2}
                        fieldLabel={t("CHEQUE_AMT")}
                        fieldPlaceholder={t(
                          "BANK_WITHDRAWAL.CHEQUE_AMT_PLACEHOLDER"
                        )}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                      />
                    </div>
                  </Col>

                  {/* Cheque Number */}
                  <Col xs={6}>
                    <div className="mb-4">
                      <NumericFormatField
                        fieldName="reference"
                        fieldValue={values.reference}
                        fieldLabel={t("CHEQUE_NUMBER")}
                        fieldPlaceholder={t(
                          "BANK_WITHDRAWAL.CHEQUE_NUM_PLACEHOLDER"
                        )}
                        allowLeadingZeros={true}
                        useThousandSeparator={false}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                      />
                    </div>
                  </Col>
                </Row>
              </ModalBody>

              <ModalFooter>
                <Button color="light" onClick={() => toggleModal()}>
                  {t("CANCEL")}
                </Button>

                {/* Submit Button */}
                <div className="">
                  <Button
                    type="submit"
                    color="primary"
                    className="w-md waves-effect waves-light"
                    disabled={isSubmitting || isLoading}
                  >
                    {isSubmitting || isLoading
                      ? t("PLEASE_WAIT")
                      : t("CONFIRM")}
                  </Button>
                </div>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </React.Fragment>
  );
}

export default ConfirmSaveDataBankWithdrawal;
